import { FC } from 'react';

import MaterialIcon from '../../../components/MaterialIcon/MaterialIcon';
import { useIsMobile } from '../../../services/hooks/useIsMobile';
import styles from './StarRating.module.scss';

const STAR_SIZES = {
  mobile: 24,
  desktop: 32
};

interface StarRatingProps {
  isMobile: boolean;
  starBackgroundColor?: string;
  starColor?: string;
  value: number;
}

export const Star: FC<StarRatingProps> = (
  { value, starColor, starBackgroundColor, isMobile }
) => {
  const STAR_SIZE = STAR_SIZES[isMobile ? 'mobile' : 'desktop'];

  const containerStarStyle = {
    width: STAR_SIZE,
    height: STAR_SIZE,
    zIndex: 1,
    position: 'relative' as const,
  };
  const dynamicStarStyle = {
    width: STAR_SIZE * value,
    height: STAR_SIZE,
    alignItems: 'center',
    overflow: 'hidden',
  };

  const dynamicBackgroundStarStyle = {
    width: STAR_SIZE,
    height: STAR_SIZE,
  };

  return (
    <div style={containerStarStyle}>
      <div style={dynamicStarStyle}>
        <MaterialIcon color={starColor} name="star" size={STAR_SIZE} />
      </div>
      {!!starBackgroundColor && (
        <div className={styles.backgroundStar} style={dynamicBackgroundStarStyle}>
          <MaterialIcon color={starBackgroundColor} name="star" size={STAR_SIZE} />
        </div>
      )}
    </div>
  );
};

const StarRating: FC<StarRatingProps> = ({ value, starColor, starBackgroundColor }) => {
  const isMobile = useIsMobile();

  const full = Math.floor(value);
  const decimal = value - full;
  const starValues = new Array(full).fill(1);

  if (decimal) {
    starValues.push(decimal);
  }

  if (starBackgroundColor) {
    const starsLeft = new Array(5 - starValues.length).fill(0);
    starValues.push(...starsLeft);
  }

  return (
    <div className={styles.starsContainer}>
      {starValues.map((value: number, index: number) => (
        <Star
          isMobile={isMobile}
          key={index}
          starBackgroundColor={starBackgroundColor}
          starColor={starColor}
          value={value}
        />
      ))}
    </div>
  );
};

export default StarRating;
